import gsap from 'gsap';
import ScrollMagic from 'scrollmagic';

function top_parallax(easeScenes, controller) {
  let imageLeft = document.querySelectorAll(".main-design__gallery--left .gallery_image");
  let imageRight = document.querySelector(".main-design__gallery--right .gallery_image");
  let imageBottom = document.querySelector(".main-design__gallery--bottom .gallery_image");

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })
    .set(imageRight, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageLeft, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageBottom, {
      scale: 1.2,
      immediateRender: true
    })
    .from(imageLeft, {
      yPercent: -10,
      // duration: 1.1
    })
    .fromTo(imageRight, {
      yPercent: 5
    }, {
      yPercent: -5,
      // duration: 1.1
    }, 0)
    .fromTo(imageBottom, {
      yPercent: -10
    }, {
      yPercent: 10
    })

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-design__gallery",
    triggerHook: 0.5,
    duration: "250%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene
  });
}

function top_parallax_a(easeScenes, controller) {
  let imageLeft = document.querySelectorAll(".main-design-black__gallery--left .gallery_image.a-type");
  let imageRight = document.querySelector(".main-design-black__gallery--right .gallery_image.a-type");

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })
    .set(imageRight, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageLeft, {
      scale: 1.2,
      immediateRender: true
    })
    .from(imageLeft, {
      yPercent: -10,
      // duration: 1.1
    })
    .fromTo(imageRight, {
      yPercent: 5
    }, {
      yPercent: -5,
      // duration: 1.1
    }, 0)

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-design-black__gallery",
    triggerHook: 1,
    duration: "250%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene
  });
}

function bottom_parallax(easeScenes, controller) {
  let imageTop = document.querySelectorAll(".bike-gallery__top img");
  let imageLeft = document.querySelectorAll(".bike-gallery__left img");
  let imageRight = document.querySelector(".bike-gallery__right img");
  let imageBottom = document.querySelector(".bike-gallery__bottom img");
  let bikeGallery = $(".bike-gallery");
  let galleryTop = $(".bike-gallery__top");
  let galleryMiddle = $(".bike-gallery__middle");
  let galleryBottom = $(".bike-gallery__bottom");

  let tween = gsap.to({}, {})
  let follower = gsap.to({}, {});

  let scene = new ScrollMagic.Scene({
    triggerElement: ".bike-gallery",
    triggerHook: 0.5,
  })
    .setTween(tween)
    .addTo(controller)

  let easingScene = {
    tween: tween,
    follower: follower,
    scene: scene,
    update: function () {
      let galleryHeight = bikeGallery.height() + window.innerHeight / 2,
        topHeight = galleryTop.height(),
        middleHeight = galleryMiddle.height(),
        bottomHeight = galleryBottom.height();

      easingScene.follower = gsap.timeline({
        paused: true
      })
        .set(imageTop, {
          scale: 1.3,
          immediateRender: true
        })
        .set(imageRight, {
          scale: 1.3,
          immediateRender: true
        })
        .set(imageLeft, {
          scale: 1.3,
          immediateRender: true
        })
        .set(imageBottom, {
          scale: 1.3,
          immediateRender: true
        })
        .fromTo(imageTop, {
          yPercent: 10
        }, {
          yPercent: -10,
          // duration: topHeight / galleryHeight
        })
        .fromTo(imageLeft, {
          yPercent: -5,
        }, {
          yPercent: 15,
          // duration: middleHeight / galleryHeight
        }, topHeight / galleryHeight)
        .fromTo(imageRight, {
          yPercent: 10
        }, {
          yPercent: -10,
          // duration: middleHeight / galleryHeight
        }, topHeight / galleryHeight)
        .fromTo(imageBottom, {
          yPercent: 10
        }, {
          yPercent: -10,
          // duration: bottomHeight / galleryHeight
        });

      scene.duration(galleryHeight);
    }
  }
  easingScene.update();

  $(".bike-gallery img").each(function () {
    if (this.complete) {
      easingScene.update();
    } else {
      $(this).on("load", imageLoaded);

      function imageLoaded() {
        $(this).off("load", imageLoaded);
        easingScene.update();
      }
    }
  });

  easeScenes.push(easingScene);
}

function top_parallax_city(easeScenes, controller) {
  let imageLeft = document.querySelectorAll(".city_gallery_first .main-design__gallery--left .gallery_image");
  let imageRight = document.querySelector(".city_gallery_first .main-design__gallery--right .gallery_image");
  let imageBottom = document.querySelector(".city_gallery_first .main-design__gallery--bottom .gallery_image");

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })
    .set(imageRight, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageLeft, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageBottom, {
      scale: 1.2,
      immediateRender: true
    })
    .from(imageLeft, {
      yPercent: -10,
      duration: 1.1
    })
    .fromTo(imageRight, {
      yPercent: 5
    }, {
      yPercent: -5,
      duration: 1.1
    }, 0)
    .fromTo(imageBottom, {
      yPercent: -10
    }, {
      yPercent: 10
    })

  let scene = new ScrollMagic.Scene({
    triggerElement: ".city_gallery_first",
    triggerHook: 0.5,
    duration: "250%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene
  });
}

function bottom_parallax_city(easeScenes, controller) {
  let imageLeft = document.querySelectorAll(".city_gallery_second .main-design__gallery--left .gallery_image");
  let imageRight = document.querySelector(".city_gallery_second .main-design__gallery--right .gallery_image");
  let imageBottom = document.querySelector(".city_gallery_second .main-design__gallery--bottom .gallery_image");

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })
    .set(imageRight, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageLeft, {
      scale: 1.2,
      immediateRender: true
    })
    .set(imageBottom, {
      scale: 1.2,
      immediateRender: true
    })
    .from(imageLeft, {
      yPercent: -10,
      duration: 1.1
    })
    .fromTo(imageRight, {
      yPercent: 5
    }, {
      yPercent: -5,
      duration: 1.1
    }, 0)
    .fromTo(imageBottom, {
      yPercent: -10
    }, {
      yPercent: 10
    })

  let scene = new ScrollMagic.Scene({
    triggerElement: ".city_gallery_second",
    triggerHook: 0.5,
    duration: "250%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene
  });
}

function parallax_discover(controller) {
  new ScrollMagic.Scene({
    triggerElement: '.city_discover_bg',

  })
    .setTween('.city_discover_bg img', {scale: 1.2})
    .addTo(controller)
}

export {
  top_parallax,
  bottom_parallax,
  top_parallax_city,
  bottom_parallax_city,
  parallax_discover,
  top_parallax_a
}
